import { Trans } from '~/common/context';

type Props = {
  viewPrice: boolean;
};

function WcwTableHeader({ viewPrice }: Props) {
  return (
    <thead className='align-middle'>
      <tr>
        <th className='px-2 text-center' id='product'>
          <Trans i18nKey='app.purchase.table.product' />
        </th>
        <th className='px-2 text-center' id='description'>
          <Trans i18nKey='app.common.description' />
        </th>
        <th className='px-2 text-center' id='recommended-price'>
          <Trans i18nKey='app.purchase.wcw.result_page.recommended_price' />
        </th>
        <th className='px-2 text-center' id='supplier'>
          <Trans i18nKey='app.purchase.wcw.result_page.source' />
        </th>
        <th className='px-2 text-center' id='delivery'>
          <Trans i18nKey='app.common.estimation_delivery' />
        </th>
        <th className='px-2 text-center' id='quantity'>
          <Trans i18nKey='app.common.quantity' />
        </th>
        {viewPrice && (
          <th className='px-2 text-center' id='price-ht'>
            <Trans i18nKey='app.common.price.tax_excluded' />
          </th>
        )}
        <th className='px-2 text-center' id='action'>
          <Trans i18nKey='app.common.actions' />
        </th>
      </tr>
    </thead>
  );
}

export default WcwTableHeader;
